export default "__VITE_ASSET__RV6Ko1N___"